(function($) {

    var RTL2IframePlayer = function(element, options) {

        var elem = $(element);
        var obj = this;


        var iframeBaseUrl = buildEnv.env == 'test' ? 'https://t-player.rtl2.de' : 'https://player.rtl2.de'
        var iframePath = '/'
        var iframeQueryParams = {}


        /* ================================================================================================
         * DEFAULT SETTINGS
         * ============================================================================================= */

        var settings = $.extend( {}, {

            dev: false, // Entwickler Modus, zb um absolute Pfade zu verwenden
            legacy: false, // jw7 oder jw6

            internal: false, // interner Player muss kein CSS nachladen
            loadData: true, // Settings werden auch aus DOM Element geladen
            standby: false, // nicht sofort JWPlayer laden, für lazyload
            appmode: false, // Modus für Go-App

            source: false, // Video Quelle manuell angeben

            basePath: '',

            playerJS: "%basePath%/sites/default/modules/rtl2/jwplayer/jwplayer-7.6.0/jwplayer.js",
            playerSWF: "%basePath%/sites/default/modules/rtl2/jwplayer/jwplayer-7.6.0/jwplayer.flash.swf",
            primaryRenderingMode: "flash",

            vipoAPI: "%basePath%/sites/default/modules/rtl2/mediathek/php/get_video_jw.php",
            vipoPlaylistAPI: "%basePath%/sites/default/modules/rtl2/mediathek/php/get_video_playlist_jw.php",
            relatedAPI: "%basePath%/sites/default/modules/rtl2/mediathek/php/get_video_related.php",

            skinName: "rtl2",
            skinURL: "%basePath%/sites/default/themes/rtl2_5_theme/css-min/rtl2.jwplayer.css",
            cornerlogo: "%basePath%/sites/default/modules/rtl2/jwplayer/assets/img/rtl2.svg",

            ads: true,
            adClient: 'vast',

            showRelated: false,
            showLogo: false,
            autostart: false,
            mute: false,
            repeat: false,

            displaytitle: true,
            displaydescription: false,

            revolverPlay: false,
            revolverDelay: 12,
            mediathek: false,
            controls: true,
            playlist: false,
            visualplaylist: true,
            boolFullSize: false,

            playerWidth: 650,
            playerHeight: 366,
            playerAspectratio: "16:9",
            useAspectRatio: false,

            trackGA: true,
            trackET: true,
            trackIVW: true,

            trackLive: false,
            trackLiveInterval: 60,


            loc: escape(window.location),
            debug: false

        }, options || {});

        /* ================================================================================================
         * CUSTOM SOURCE
         * ============================================================================================= */

        if(typeof options.source === 'object') {
            settings.source = $.extend({
                titel: "",
                beschreibung: "",
                image: "https://player.rtl2.de/assets/placeholder.png",
                poster: "https://player.rtl2.de/assets/placeholder.png",
                OVERLAY: "",
                PREROLL: "",
                MIDROLL: "",
                POSTROLL: "",
                trackingID: undefined
            }, options.source);
        }
        else {
            // obj.debug('sodale',typeof options.source, options);
        }

        this.init = function() {
            if (settings.loadData == true) {
                settings = $.extend({}, settings, elem.data());
            }

            // iframeQueryParams['env'] = 'dev'

            var iframeSettings = {
                jwOptions: {
                    autostart: settings.autostart,
                    displaytitle: settings.displaytitle,
                    displaydescription: settings.displaydescription
                },
                ads: settings.ads,
                showLogo: settings.showLogo,
                ivw: {
                    active: false,
                    iam_data: {
                        // cp: 'aaaaaaaa' TODO
                    }
                },
                source: settings.source
            }

            // IVW Code übermitteln
            if(typeof iam_data !== 'undefined') {
                iframeSettings.ivw.active = true
                iframeSettings.ivw.iam_data.st = iam_data.st
                iframeSettings.ivw.iam_data.cp = iam_data.cp
            }

            iframeQueryParams['o'] = btoa(JSON.stringify(iframeSettings))

            var container = document.createElement("div")
            $(container).css('position','relative')
                .css('background','#000')
                // .css('width','100%')
                .css('padding-top','56.25%')

            var ifrm = document.createElement("iframe")
            ifrm.style.position = "absolute"
            ifrm.style.top = "0"
            ifrm.style.left = "0"
            ifrm.style.right = "0"
            ifrm.style.bottom = "0"
            ifrm.style.width = "100%"
            ifrm.style.height = "100%"
            ifrm.setAttribute("frameborder", 0)
            ifrm.setAttribute("allowfullscreen", 1)
            ifrm.setAttribute("allowautoplay", 1)
            ifrm.setAttribute("allow", "autoplay; fullscreen")
            ifrm.referrerPolicy = "unsafe-url";

            //SOURCE
            if(settings.source) {
                iframePath = '/source'
            }
            else {
                //VIPO
                var vico_id = settings.vico_id || settings.collection
                var vivi_id = settings.vivi_id || settings.video
                var bonr = settings.bonr || null


                if(bonr) {
                    iframePath = '/vipo/bonr/'+bonr
                }
                else if(vivi_id && vico_id) {
                    iframePath = '/vipo/'+vico_id+'/'+vivi_id
                    // ifrm.setAttribute("src", "http://player.rtl2.de/vipo/"+vico_id+"/"+vivi_id)
                }
                else if(settings.playlist && vico_id) {
                    iframePath = '/vico/'+vico_id
                    iframeQueryParams['plm'] = 0
                    // ifrm.setAttribute("src", "http://player.rtl2.de/vipo/"+vico_id+"?plm=0")
                }


                if(settings.playlist || settings.revolverPlay) {
                    iframeQueryParams['rel'] = 1
                }
            }

            ifrm.setAttribute("src", iframeBaseUrl + iframePath + '?' + encodeData(iframeQueryParams) )



            $(container).append(ifrm)
            $(element).html(container)
        }

        function encodeData(data) {
            return Object.keys(data).map(function(key) {
                return [key, data[key]].map(encodeURIComponent).join("=");
            }).join("&");
        }

        this.init()

    }


    $.fn.rtl2player = $.fn.rtl2player_lazyload = function(options) {

        return this.each(function()
        {
            var element = $(this);

            // Return early if this element already has a plugin instance
            if (element.data('rtl2player')) return;

            var rtl2player = new RTL2IframePlayer(this, options);

            // Store plugin object in this element's data
            element.data('rtl2player', rtl2player);
        });
    };
}(jQuery));



// WEBPACK FOOTER //
// ./src/scripts/rtl2player.jquery.js